module.exports = __webpack_public_path__ + "static/rolecek-eac63500d8253c7ae1d1b8d22b0dfd16.jpg";